import { render, staticRenderFns } from "./ServiceSliderSelector.vue?vue&type=template&id=bd9a2bae&scoped=true&"
import script from "./ServiceSliderSelector.vue?vue&type=script&lang=ts&"
export * from "./ServiceSliderSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9a2bae",
  null
  
)

export default component.exports